import { ENV_CONFIG_BUILD_APP_NAME, ReactRootAppName } from './env';

const auth0Namespace = 'https://getcone.io';

export const DEFAULT_PAGE_SIZE = 20;
export const LOCAL_STORAGE_MENU_KEY = 'SHOW_SUB_MENU';

export const AUTH0_ROLES_KEY = `${auth0Namespace}/roles`;
export const AUTH0_CONNECTION_NAME_KEY = `${auth0Namespace}/connection_name`;

export const BACKEND_DATE_STRING_FORMAT = 'YYYY-MM-DD';

export const PRODUCT_NAMES = {
  CONE: 'Cone',
  P2P: 'Proposal-to-Payment',
  PM: 'WorkOS',
};

export const APP_PATH_PREFIX = {
  APP: '/app',
  P2P: '/proposal',
  PM: '/pm',
  PM_CLIENT:
    ENV_CONFIG_BUILD_APP_NAME === ReactRootAppName.PmClient ? '' : '/pm-client',
};

export enum ConeProduct {
  P2P = 'p2p',
  PM = 'pm',
  PM_CLIENT = 'pm-client',
}

export enum ConeUserRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  STANDARD_USER = 'standard-user',
  RESTRICTED_USER = 'restricted-user',
}

export enum GlobalAuth0Role {
  SuperAdmin = 'super-admin',
}

export enum TailwindThemeName {
  Slate = 'slate',
  Gray = 'gray',
  Red = 'red',
  Orange = 'orange',
  Amber = 'amber',
  Yellow = 'yellow',
  Lime = 'lime',
  Green = 'green',
  Emerald = 'emerald',
  Teal = 'teal',
  Cyan = 'cyan',
  Sky = 'sky',
  Blue = 'blue',
  Indigo = 'indigo',
  Violet = 'violet',
  Purple = 'purple',
  Fuchsia = 'fuchsia',
  Pink = 'pink',
  Rose = 'rose',
}

export const DEFAULT_THEME_NAME = TailwindThemeName.Slate;
export const DEFAULT_USER_LOCALE = 'en-GB';
export const DEFAULT_USER_CURRENCY = 'GBP';
export const DEFAULT_USER_TIMEZONE = 'Europe/London';

export enum ConeUserAccessPermissions {
  CLIENT_ARCHIVE = 'client.archive',
  CLIENT_BULK_IMPORT = 'client.bulk-import',
  CLIENT_CREATE = 'client.create',
  CLIENT_DASHBOARD = 'client.dashboard',
  CLIENT_DELETE = 'client.delete',
  CLIENT_INVOICE = 'client.invoice',
  CLIENT_MEMBERS = 'client.members',
  CLIENT_MODIFY = 'client.modify',
  CLIENT_VIEW = 'client.view',
  CLIENT_PAYMENT_EDIT = 'client.payment-edit',
  CLIENT_PAYMENT_HISTORY = 'client.payment-history',
  CLIENT_PAYMENT_VIEW = 'client.payment-view',
  CLIENT_PORTAL = 'client.portal',
  CLIENT_REQUEST_ASSIGNEE = 'client-request.assignee',
  CLIENT_REQUEST_CREATE = 'client-request.create',
  CLIENT_REQUEST_DELETE = 'client-request.delete',
  CLIENT_REQUEST_MODIFY = 'client-request.modify',
  CLIENT_REQUEST_SHARE = 'client-request.share',
  CLIENT_REQUEST_VIEW = 'client-request.view',
  CONTACT_VIEW = 'contact.view',
  CONTACT_CREATE = 'contact.create',
  CONTACT_MODIFY = 'contact.modify',
  CONTACT_INVITE = 'contact.invite',
  DEAL_CREATE = 'deal.create',
  DEAL_DELETE = 'deal.delete',
  DEAL_MODIFY = 'deal.modify',
  DEAL_VIEW = 'deal.view',
  EMAIL_TEMPLATE_CREATE = 'email-template.create',
  EMAIL_TEMPLATE_DELETE = 'email-template.delete',
  EMAIL_TEMPLATE_MODIFY = 'email-template.modify',
  EMAIL_TEMPLATE_VIEW = 'email-template.view',
  ENGAGEMENT_LETTER_TEMPLATE_CREATE = 'engagement-letter-template.create',
  ENGAGEMENT_LETTER_TEMPLATE_DELETE = 'engagement-letter-template.delete',
  ENGAGEMENT_LETTER_TEMPLATE_MODIFY = 'engagement-letter-template.modify',
  ENGAGEMENT_LETTER_TEMPLATE_VIEW = 'engagement-letter-template.view',
  FILE_VIEW = 'file.view',
  FILE_RENAME = 'file.rename',
  FORM_TEMPLATE_CREATE = 'form-template.create',
  FORM_TEMPLATE_DELETE = 'form-template.delete',
  FORM_TEMPLATE_MODIFY = 'form-template.modify',
  FORM_TEMPLATE_VIEW = 'form-template.view',
  FOLDER_CREATE = 'folder.create',
  FOLDER_TEMPLATE_CREATE = 'folder-template.create',
  FOLDER_TEMPLATE_DELETE = 'folder-template.delete',
  FOLDER_TEMPLATE_MODIFY = 'folder-template.modify',
  FOLDER_TEMPLATE_VIEW = 'folder-template.view',
  INTEGRATION_CREATE = 'integration.create',
  INTEGRATION_DELETE = 'integration.delete',
  INTEGRATION_MODIFY = 'integration.modify',
  INTEGRATION_VIEW = 'integration.view',
  INVOICE_CANCEL = 'invoice.cancel',
  INVOICE_CREATE = 'invoice.create',
  INVOICE_DELETE = 'invoice.delete',
  INVOICE_MODIFY = 'invoice.modify',
  INVOICE_VIEW = 'invoice.view',
  PAYMENT_DASHBOARD = 'payment.dashboard',
  PAYMENT_SETTINGS = 'payment.settings',
  PROJECT_CREATE = 'project.create',
  PROJECT_DELETE = 'project.delete',
  PROJECT_MODIFY = 'project.modify',
  PROJECT_VIEW = 'project.view',
  PROJECT_STATUS = 'project.status',
  PROJECT_TEMPLATE_CREATE = 'project-template.create',
  PROJECT_TEMPLATE_DELETE = 'project-template.delete',
  PROJECT_TEMPLATE_MODIFY = 'project-template.modify',
  PROJECT_TEMPLATE_VIEW = 'project-template.view',
  PROPOSAL_CREATE = 'proposal.create',
  PROPOSAL_DELETE = 'proposal.delete',
  PROPOSAL_MODIFY = 'proposal.modify',
  PROPOSAL_RECALL = 'proposal.recall',
  PROPOSAL_RENEW = 'proposal.renew',
  PROPOSAL_VIEW = 'proposal.view',
  PROPOSAL_PUBLISH = 'proposal.publish',
  PROPOSAL_TEMPLATE_CREATE = 'proposal-template.create',
  PROPOSAL_TEMPLATE_DELETE = 'proposal-template.delete',
  PROPOSAL_TEMPLATE_MODIFY = 'proposal-template.modify',
  PROPOSAL_TEMPLATE_VIEW = 'proposal-template.view',
  RECURRING_RULE_CREATE = 'recurring_rule.create',
  REPORTS_BILLING = 'reports.billing',
  REPORTS_CLIENT_PROFITABILITY = 'reports.client-profitability',
  REPORTS_CLIENT_TIME = 'reports.client-time',
  REPORTS_CLIENTS = 'reports.clients',
  REPORTS_DEALS = 'reports.deals',
  REPORTS_FIRM_PROFITABILITY = 'reports.firm-profitability',
  REPORTS_PAYMENTS = 'reports.payments',
  REPORTS_PROPOSALS = 'reports.proposals',
  REPORTS_TEAM_UTILISATION = 'reports.team-utilisation',
  SECTION_TEMPLATE_CREATE = 'section-template.create',
  SECTION_TEMPLATE_DELETE = 'section-template.delete',
  SECTION_TEMPLATE_MODIFY = 'section-template.modify',
  SECTION_TEMPLATE_VIEW = 'section-template.view',
  SERVICE_CREATE = 'service.create',
  SERVICE_DELETE = 'service.delete',
  SERVICE_MODIFY = 'service.modify',
  SERVICE_VIEW = 'service.view',
  SETTINGS_ADD_MODIFY_SIGNATURE = 'settings.add-modify-signature',
  SETTINGS_ADD_PEOPLE = 'settings.add-people',
  SETTINGS_ADD_PERMISSION_SETS = 'settings.add-permission-sets',
  SETTINGS_BILLING_OVERVIEW = 'settings.billing-overview',
  SETTINGS_DELETE_PEOPLE = 'settings.delete-people',
  SETTINGS_DELETE_PERMISSION_SETS = 'settings.delete-permission-sets',
  SETTINGS_GENERAL = 'settings.general',
  SETTINGS_GENERAL_VIEW = 'settings.general-view',
  SETTINGS_MODIFY_PEOPLE = 'settings.modify-people',
  SETTINGS_MODIFY_WORKFLOW = 'settings.modify-workflow',
  SETTINGS_PEOPLE_RATE_HOURS = 'settings.people-rates-hours',
  SETTINGS_UPDATE_BILLING = 'settings.update-billing',
  SETTINGS_UPDATE_BRANDING = 'settings.update-branding',
  SETTING_UPDATE_INVOICE = 'settings.update-invoice',
  SETTINGS_UPDATE_PAYMENT = 'settings.update-payment',
  SETTINGS_UPDATE_TAX = 'settings.update-tax',
  SETTINGS_UPDATE_CUSTOM_STATUS = 'settings.update-custom-status',
  SETTINGS_UPDATE_PERMISSION_SETS = 'settings.update-permission-sets',
  SETTINGS_UPDATE_REMINDERS = 'settings.update-reminders',
  SETTINGS_VIEW_BILLING = 'settings.view-billing',
  SETTINGS_VIEW_BRANDING = 'settings.view-branding',
  SETTINGS_VIEW_CUSTOM_STATUS = 'settings.view-custom-status',
  SETTINGS_VIEW_PERMISSION_SETS = 'settings.view-permission-sets',
  SETTINGS_VIEW_PEOPLE = 'settings.view-people',
  SETTINGS_VIEW_REMINDERS = 'settings.view-reminders',
  SETTINGS_VIEW_SIGNATURE = 'settings.view-signature',
  SETTINGS_VIEW_WORKFLOW = 'settings.view-workflow',
  TAB_BILLING = 'tab.billing',
  TAB_CLIENTS = 'tab.clients',
  TAB_CONTACTS = 'tab.contacts',
  TAB_DEALS = 'tab.deals',
  TAB_FILES = 'tab.files',
  TAB_INBOX = 'tab.inbox',
  TAB_PAYMENTS = 'tab.payments',
  TAB_PROPOSALS = 'tab.proposals',
  TAB_REPORTS = 'tab.reports',
  TAB_SERVICES = 'tab.services',
  TAB_SETTINGS = 'tab.settings',
  TAB_TASK_PERMISSIONS = 'tab.task-permissions',
  TAB_TEMPLATES = 'tab.templates',
  TAB_TIME = 'tab.time',
  TAB_WORK = 'tab.work',
  TASK_ASSIGNEE = 'task.assignee',
  TASK_CREATE = 'task.create',
  TASK_DELETE = 'task.delete',
  TASK_MODIFY = 'task.modify',
  TASK_VIEW = 'task.view',
  TASK_STATUS = 'task.status',
  TEMPLATE_CREATE = 'template.create',
  TEMPLATE_DELETE = 'template.delete',
  TEMPLATE_MODIFY = 'template.modify',
  TEMPLATE_VIEW = 'template.view',
  TIME_ENTRY_CREATE = 'time-entry.create',
  TIME_ENTRY_DELETE = 'time-entry.delete',
  TIME_ENTRY_INSIGHT = 'time-entry.insight',
  TIME_ENTRY_MODIFY = 'time-entry.modify',
  TIME_ENTRY_VIEW = 'time-entry.view',
  SUBSCRIPTION_ADD = 'subscription.add',
  SUBSCRIPTION_VIEW = 'subscription.view',
}

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const DEFAULT_USER_ROLES = [
  ConeUserRole.OWNER,
  ConeUserRole.ADMIN,
  ConeUserRole.STANDARD_USER,
  ConeUserRole.RESTRICTED_USER,
];
